import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { googleSession, apiError } from '@/api/account';
import { useCustomerAuth } from '@/context/CustomerAuthContext';

// Rendered by App when the URL fragment carries `session_id=` (return from auth.emergentagent.com).
export function AuthCallback() {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const { setCustomer } = useCustomerAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(hash.replace(/^#/, '')).get('session_id');
    (async () => {
      try {
        const user = await googleSession(sessionId);
        setCustomer(user);
        navigate('/account', { replace: true, state: { user, isNew: Boolean(user.is_new) } });
      } catch (err) {
        navigate('/login', { replace: true, state: { error: apiError(err, 'Google sign-in failed. Please try again.') } });
      }
    })();
  }, [hash, navigate, setCustomer]);

  return (
    <div data-testid="auth-callback" className="min-h-[60vh] grid place-items-center bg-[#F5F5F3]">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-[#EE5A01] animate-spin mx-auto" />
        <p className="mt-4 font-heading font-bold text-sm text-[#121212]">Signing you in…</p>
      </div>
    </div>
  );
}
